export default "__VITE_ASSET__4dd42953__"